<template lang="html">
    <li class="main-menu__item" v-if="user && user.isDeveloper">
        <router-link
            v-bind:to="{ name: 'Overview'}"
            v-bind:class="{[settingsLinkActiveClass]: ['Overview', 'ModulesOverview'].indexOf(settingLink)+1}"
        >
            <span>Свойства, сущности и действия модулей</span>
        </router-link>
    </li>
</template>
<script>
    export default {
        name: 'module-settings-menu',
        sort: 7,
        module: 'module',
        data() {
            return {
                sort: 7,
                module: 'module',
            }
        },
        computed: {
            user() {
                return this.$store.state.users.current;
            },
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }            
        }
    }
</script>



// WEBPACK FOOTER //
// SettingsMenu.vue?ce2c3d12